import rest from '../rest';
import { year } from '../mock.constants';
import { contractTypeData, appointmentTypesData } from './typesResponse';

const contractTypes = [
	rest.get('/api/v2/contracts/types', (req, res, ctx) => res(ctx.json(contractTypeData))),
	rest.get(`/api/v2/contracts/types?qualificationYear=${year}`, (req, res, ctx) => res(ctx.json(contractTypeData))),
	rest.get('/api/v2/appointments/types/:year/:grouping', (req, res, ctx) => {
		let { grouping } = req.params;
		grouping = decodeURIComponent(grouping);
		const content = {
			status: 200,
			data: appointmentTypesData[grouping] || { count: 0, data: [], error: []},
		};
		return res(ctx.json(content));
	}),
];

export default contractTypes;
